/**
 * React Query keys for HR leave. Kept in a separate file so the hook module
 * can use Fast Refresh (only hook/component exports).
 */
export const LEAVES_QUERY_KEY = ['hr', 'leave'];
export const LEAVE_DETAIL_QUERY_KEY = (id) => ['hr', 'leave', 'detail', id];
